const baseStyle = () => ({
  _list: {
    flexDirection: 'column',
    marginBottom: 3,
  },
  _item: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    marginBottom: 1,
  },
  _bullet: {
    bgColor: 'darkText',
    borderRadius: 'sm',
    height: '5px',
    marginLeft: 1,
    marginRight: 2,
    marginTop: (24 - 5) / 2 + 'px',
    width: '5px',
  },
  _text: {
    color: 'inherit',
    fontStyle: 'normal',
    fontFamily: 'sans-serif',
    fontWeight: 400,
    fontSize: 'md',
    lineHeight: 'md',
    flexShrink: 1,
  },
});

export default {
  baseStyle,
};
